<template>
  <div class="app">
    <!-- ================= 视图一：支付结果确认 ================= -->
    <section class="view" v-show="status === 'ask'">
      <header class="topbar">
        <h1 class="topbar-title" style="width: 100%;text-align:center;">订单支付</h1>
      </header>
      <!--
      <div class="hero">
        <span class="hero-badge">
          <svg viewBox="0 0 24 24" fill="currentColor">
            <path
              d="M12 2 4 5.5v5.6c0 5 3.4 9.4 8 10.9 4.6-1.5 8-5.9 8-10.9V5.5L12 2z"
            />
          </svg>
          银联卡礼遇 · 支付确认
        </span>
        <h1 class="hero-title">支付完成了吗？</h1>
        <p class="hero-sub">请确认您的支付结果，避免重复支付或漏单</p>
      </div>-->

      <main class="content">
        <section class="order-card">
          <h2>订单信息</h2>
          <div class="o-row">
            <span class="o-label">订单号</span>
            <div class="o-val-wrap">
              <b class="o-orderno">{{ orderNoText }}</b>
            </div>
          </div>
          <div class="o-row">
            <span class="o-label">商品</span
            ><b class="o-val">{{ productNameText }}</b>
          </div>
          <div class="o-row">
            <span class="o-label">应付金额</span
            ><b class="o-amount"><small>¥</small>{{ amountText }}</b>
          </div>
          <div class="o-row">
            <span class="o-label">下单时间</span
            ><b class="o-val">{{ payTime }}</b>
          </div>
        </section>

        
      </main>

      <div class="action-bar">
        <button class="btn-paid" @click="onPaid">去支付</button>
        <button class="btn-notpaid" @click="onNotPaid">返回权益平台</button>
      </div>
    </section>

    <!-- ================= 视图二：确认完成 ================= -->
    <section class="view" v-show="status === 'done'">
      <div class="success-wrap">
        <div class="success-icon">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2.6"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        </div>
        <h1>确认完成</h1>
        <p class="success-sub">已为您确认支付成功</p>
        <div class="success-card">
          <div class="s-name">{{ productNameText }}</div>
          <div class="s-row">
            <span>订单号</span><b>{{ orderNoText }}</b>
          </div>
          <div class="s-row">
            <span>实付金额</span><b class="s-amount">¥{{ amountText }}</b>
          </div>
        </div>
        <p class="success-tip">如支付状态有误，请致电客服 400-998-9999</p>
        <button class="btn-primary" @click="onDone" style="background: #ff5722">
          去商城
        </button>
        <button class="btn-primary" @click="onDone2">返回权益平台</button>
      </div>
    </section>
  </div>
</template>
<script>
import { Toast, Indicator } from "mint-ui";
import {qypayinfo,qybuypay} from "../../api/uniqyOrderH5";

export default {
  name: "JzuniPayNotify",
  data: function () {
    return {
      status: "ask", // 当前视图: ask 询问 / done 确认完成
      orderNoText: "", // 展示用订单号
      productNameText: "", // 展示用商品名
      amountText: "0.01", // 展示用金额（两位小数）
      payTime: "", // 下单时间
      token: "", //跳转备用token
      qbackUrl: "", //返回权益平台地址
      orderId: this.$route.query.orderId ? this.$route.query.orderId : 0, //从路由中获取变量
      member_id:0,
      pay_sn:0,
      order_sn:0,
    };
  },
  created: function () {
    this.initialize(); //初始化数据
  },
  methods: {
    async initialize() {
      Indicator.open();
      let res = await qypayinfo(this.orderId);
      Indicator.close();
      if (res.data.code == "10001") {
        Toast(res.data.message);
        setTimeout(() => {
          window.location.href = "/home/index";
        }, 1000);
      }
      else if(res.data.code == "12001"){//订单已支付
        this.orderNoText = res.data.result.orderNoText;
        this.productNameText = res.data.result.productNameText;
        this.amountText = res.data.result.amountText;
        this.payTime = res.data.result.payTime;
        this.token = res.data.result.token;
        this.pay_sn=res.data.result.pay_sn;
        this.member_id=res.data.result.member_id;
        this.qbackUrl=res.data.result.qbackUrl;
        this.status="done";
        this.order_sn=res.data.result.order_sn;
      } 
      else {
        this.orderNoText = res.data.result.orderNoText;
        this.productNameText = res.data.result.productNameText;
        this.amountText = res.data.result.amountText;
        this.payTime = res.data.result.payTime;
        this.token = res.data.result.token;
        this.pay_sn=res.data.result.pay_sn;
        this.member_id=res.data.result.member_id;
        this.qbackUrl=res.data.result.qbackUrl;
        this.order_sn=res.data.result.order_sn;
      }
    },
    //发起支付
    async onPaid() {
       let that=this;
       Indicator.open({ text: '数据载入中...' });
       let res = await qybuypay(this.pay_sn,this.member_id);
       Indicator.close();
       if(res.data.code=="10000"){//发起成功,测试环境默认支付回调
           console.log(res);
           /*
           Toast('支付成功');
           setTimeout(() => {
            window.location.href ="/jzuniqy/unipayreturn?order_sn="+that.order_sn+"&pay_sn="+that.pay_sn;
           }, 1000);*/
           window.location.href=res.data.result;
           return;
       }
       else{
          Toast(res.data.message);
          return false;
       }
    },
    onDone(){
        //去商城
        window.location.href = "/home/index";
    },
    //返回权益平台
    onDone2(){
        window.location.href = this.qbackUrl;
    },
    //返回权益平台
    onNotPaid() {
      window.location.href =this.qbackUrl;
    },
  },
};
</script>
<style lang='scss'>
/* ===== 全局基础样式（必须不带 scoped） =====
   与 jzuniqy.vue 同款处理：scoped 会给选择器追加 [data-v-xxx]，
   :root / html / body 不再命中真实文档，CSS 变量会全部失效 */
:root {
  --red: #c8102e;
  --red-deep: #a50d26;
  --red-dark: #7e0a1e;
  --gold: #e9b44c;
  --gold-deep: #c9922c;
  --gold-light: #f7e5bc;
  --cream: #fdf6ea;
  --card: #ffffff;
  --ink: #3a2a1b;
  --ink2: #77674f;
  --ink3: #a6987f;
  --line: #efe3cf;
  --ok: #2e7d32;
  --warn: #d96c1f;
  --radius: 18px;
  --radius-sm: 14px;
}
html {
  font-size: 17px;
}
body {
  margin: 0;
  font-family: "Noto Sans SC", "PingFang SC", "Microsoft YaHei", system-ui,
    sans-serif;
  background: #e7dfce;
  color: var(--ink);
  line-height: 1.6;
}
</style>
<style scoped lang='scss'>
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  -webkit-tap-highlight-color: transparent;
}
button {
  font-family: inherit;
  border: none;
  background: none;
  cursor: pointer;
  color: inherit;
}
img {
  display: block;
}
:focus-visible {
  outline: 3px solid var(--gold);
  outline-offset: 2px;
  border-radius: 6px;
}
.app {
  max-width: 520px;
  margin: 0 auto;
  min-height: 100vh;
  background: var(--cream);
  position: relative;
  overflow-x: hidden;
  box-shadow: 0 0 40px rgba(60, 40, 20, 0.18);
}
.view {
  min-height: 100vh;
  padding-bottom: 120px;
}
.topbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 64px;
  padding: 0 16px;
  background: rgba(255, 255, 255, 0.97);
  border-bottom: 1px solid var(--line);
}
.icon-btn {
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--red-dark);
  background: var(--gold-light);
  transition: background 0.2s, transform 0.12s;
}
.icon-btn:active {
  background: var(--gold);
  transform: scale(0.94);
}
.topbar-title {
  font-size: 19px;
  font-weight: 700;
}
.topbar-spacer {
  width: 48px;
}
.hero {
  position: relative;
  color: #fff;
  padding: 28px 24px 30px;
  overflow: hidden;
  background: radial-gradient(
      circle at 88% 8%,
      rgba(233, 180, 76, 0.35) 0,
      rgba(233, 180, 76, 0) 42%
    ),
    radial-gradient(
      circle at 6% 95%,
      rgba(233, 180, 76, 0.28) 0,
      rgba(233, 180, 76, 0) 46%
    ),
    linear-gradient(
      135deg,
      var(--red) 0%,
      var(--red-deep) 58%,
      var(--red-dark) 100%
    );
}
.hero::after {
  content: "";
  position: absolute;
  right: -46px;
  top: -46px;
  width: 180px;
  height: 180px;
  border-radius: 50%;
  border: 22px solid rgba(255, 255, 255, 0.08);
}
.hero-badge {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 15px;
  font-weight: 500;
  letter-spacing: 1px;
  background: rgba(255, 255, 255, 0.16);
  border: 1px solid rgba(233, 180, 76, 0.7);
  color: var(--gold-light);
  padding: 6px 14px;
  border-radius: 999px;
  position: relative;
  z-index: 1;
}
.hero-badge svg {
  width: 16px;
  height: 16px;
}
.hero-title {
  font-family: "Noto Serif SC", "Songti SC", serif;
  font-size: 36px;
  font-weight: 900;
  line-height: 1.35;
  letter-spacing: 1px;
  margin: 18px 0 8px;
  position: relative;
  z-index: 1;
}
.hero-sub {
  font-size: 16px;
  color: rgba(255, 255, 255, 0.92);
  position: relative;
  z-index: 1;
  letter-spacing: 0.5px;
}
.content {
  padding: 14px 16px 0;
}
.order-card {
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 16px;
}
.order-card h2 {
  font-size: 19px;
  font-weight: 700;
  margin-bottom: 4px;
}
.o-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px dashed var(--line);
}
.o-row:last-child {
  border-bottom: none;
}
.o-label {
  font-size: 16px;
  color: var(--ink2);
  flex: none;
}
.o-val {
  font-size: 16px;
  font-weight: 700;
  text-align: right;
  word-break: break-all;
}
.o-val-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  min-width: 0;
}
.o-orderno {
  font-size: 20px;
  font-weight: 800;
  letter-spacing: 0.5px;
  color: var(--ink);
  word-break: break-all;
  line-height: 1.3;
  text-align: right;
}
.o-copy {
  flex: none;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 13.5px;
  font-weight: 700;
  color: var(--red-dark);
  background: var(--gold-light);
  border: 1px solid var(--gold);
  padding: 5px 10px;
  border-radius: 999px;
  transition: background 0.15s;
}
.o-copy:active {
  background: var(--gold);
}
.o-amount {
  font-family: "Noto Serif SC", serif;
  font-size: 26px;
  font-weight: 900;
  color: var(--red);
}
.o-amount small {
  font-size: 16px;
  font-weight: 700;
}
.notice-card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-top: 12px;
  padding: 14px;
  background: var(--gold-light);
  border: 1px solid var(--gold);
  border-radius: var(--radius-sm);
}
.notice-card svg {
  width: 22px;
  height: 22px;
  flex: none;
  color: var(--gold-deep);
  margin-top: 2px;
}
.notice-card p {
  font-size: 15.5px;
  color: var(--red-dark);
  font-weight: 500;
  line-height: 1.7;
}
.action-bar {
  position: sticky;
  bottom: 0;
  z-index: 20;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  background: rgba(255, 255, 255, 0.97);
  border-top: 1px solid var(--line);
}
.btn-paid {
  width: 100%;
  min-height: 58px;
  border-radius: 16px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 4px;
  background: linear-gradient(135deg, var(--red), var(--red-deep));
  color: #fff;
  box-shadow: 0 6px 16px rgba(200, 16, 46, 0.32);
  transition: transform 0.12s;
}
.btn-paid:active {
  transform: scale(0.98);
}
.btn-notpaid {
  width: 100%;
  min-height: 54px;
  border-radius: 16px;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 4px;
  color: var(--ink2);
  background: #f3ede0;
  border: 1.5px solid var(--line);
  transition: transform 0.12s;
}
.btn-notpaid:active {
  transform: scale(0.98);
}
.legal {
  padding: 22px 24px 18px;
  text-align: center;
  font-size: 13.5px;
  color: var(--ink3);
  line-height: 1.8;
}
.success-wrap {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px 60px;
  text-align: center;
}
.success-icon {
  width: 96px;
  height: 96px;
  border-radius: 50%;
  background: linear-gradient(135deg, #34a853, #1e7d3a);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  margin-bottom: 22px;
  box-shadow: 0 10px 26px rgba(30, 125, 58, 0.3);
  animation: pop 0.45s cubic-bezier(0.2, 1.6, 0.4, 1) both;
}
.success-icon svg {
  width: 52px;
  height: 52px;
}
@keyframes pop {
  from {
    transform: scale(0.3);
    opacity: 0;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
}
.success-wrap h1 {
  font-family: "Noto Serif SC", serif;
  font-size: 30px;
  font-weight: 900;
}
.success-sub {
  font-size: 17px;
  color: var(--ink2);
  margin-top: 6px;
}
.success-card {
  width: 100%;
  background: var(--card);
  border: 1px solid var(--line);
  border-radius: var(--radius);
  padding: 16px;
  margin: 26px 0 0;
  text-align: left;
}
.s-name {
  font-size: 17.5px;
  font-weight: 700;
  line-height: 1.4;
  padding-bottom: 10px;
  border-bottom: 1px dashed var(--line);
}
.s-row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  padding-top: 10px;
  font-size: 15.5px;
}
.s-row span {
  color: var(--ink2);
}
.s-row b {
  color: var(--ink);
  word-break: break-all;
  text-align: right;
}
.s-amount {
  font-family: "Noto Serif SC", serif;
  font-size: 20px;
  font-weight: 900;
  color: var(--red);
}
.success-tip {
  width: 100%;
  margin-top: 14px;
  padding: 12px 14px;
  background: var(--gold-light);
  border: 1px solid var(--gold);
  border-radius: var(--radius-sm);
  font-size: 15px;
  color: var(--red-dark);
  font-weight: 500;
  text-align: left;
}
.btn-primary {
  width: 100%;
  min-height: 58px;
  margin-top: 30px;
  border-radius: 16px;
  font-size: 20px;
  font-weight: 700;
  letter-spacing: 3px;
  background: linear-gradient(135deg, var(--red), var(--red-deep));
  color: #fff;
  box-shadow: 0 6px 16px rgba(200, 16, 46, 0.32);
}
@media (prefers-reduced-motion: reduce) {
  * {
    animation: none !important;
    transition: none !important;
  }
}
</style>
